// extracted by mini-css-extract-plugin
export var modal = "_da-0";